export const ORDER_STATUS = [
  { label: "Order Placed", value: "Order Placed" },
  { label: "In Progress", value: "In Progress" },
  { label: "Shipped", value: "Shipped" },
  { label: "Delivered", value: "Delivered" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Requested", value: "Requested" },
];
// Filter-only status list: extends ORDER_STATUS with "Reorder" (backend key
// "Re-Order") so orders in the reorder state can be filtered. NOT added to the
// shared ORDER_STATUS, which the Change-Order-Status dialog keeps free of
// "Re-Order" as a manually-settable transition.
export const ORDER_STATUS_FILTER = [
  ...ORDER_STATUS,
  { label: "Re-Order", value: "Re-Order" },
];
export const STATUS = [
  { label: "In Stock", value: "In_Stock" },
  { label: "Low Stock", value: "Low_Stock" },
  { label: "Out Of Stock", value: "Out_of_Stock" },
];
